import React, {useState, useEffect} from 'react';
import styles from './ums-popup-intraction.module.css';
import {UMSContent, getUmsInteractions} from './ums-popup-intraction.utils';
import {UMSTableComponent} from './UMSTableComponent';
import {
    IDataProps,
    IUMSPopupIntractionProps
} from '../../types/umsPopupIntraction.types';

export const UMSPopupIntraction: React.FC<IUMSPopupIntractionProps> = ({
    data
}) => {
    const {
        logoSrc = UMSContent.logoSrc,
        title = UMSContent.title,
        description = UMSContent.description,
        inputLabel = UMSContent.inputLabel,
        buttonLabel = UMSContent.buttonLabel
    } = data;

    const [daznId, setDaznId] = useState<string>('');
    const [datanew, setDatanew] = useState<IDataProps | {error?: boolean}>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showDetails, setShowDetails] = useState<boolean>(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDaznId(e.target.value);
    };

    const handleSubmit = async () => {
        if (!daznId) return;

        setIsLoading(true); // Start loading

        try {
            setShowDetails(false);
            setDatanew((prev) => ({...prev, error: false}));

            const data = await getUmsInteractions(daznId.trim());

            setDatanew(data ?? {error: true});
            setShowDetails(data !== null);
        } catch (error) {
            setDatanew((prev) => ({...prev, error: true}));
            console.error('Error handling UMS interactions:', error);
        } finally {
            setIsLoading(false); // End loading
        }
    };

    const handleButtonClick = () => {
        if (daznId) {
            handleSubmit();
            setDaznId(''); // Reset input after submission
        }
    };

    useEffect(() => {
        const handleKeyPress = (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                handleSubmit();
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [daznId]);

    return (
        <div className={styles.popupContainer}>
            <img src={logoSrc} alt="Logo" className={styles.logo} />
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.description}>{description}</p>
            <div className={styles.inputGroup}>
                <label htmlFor="popup-input" className={styles.inputLabel}>
                    {inputLabel}
                </label>
                <input
                    id="popup-input"
                    type="text"
                    value={daznId}
                    onChange={handleInputChange}
                    className={styles.inputBox}
                    placeholder="Enter here..."
                />
            </div>
            <button className={styles.submitButton} onClick={handleButtonClick}>
                {buttonLabel}
            </button>
            {isLoading ? (
                <div className={styles.loading}>Loading...</div>
            ) : (
                <UMSTableComponent data={datanew} showDetails={showDetails} />
            )}
        </div>
    );
};
